import script from "./DropOffArea.vue?vue&type=script&setup=true&lang=js"
export * from "./DropOffArea.vue?vue&type=script&setup=true&lang=js"

import "./DropOffArea.vue?vue&type=style&index=0&id=5ec23630&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ec23630"]])

export default __exports__